export default "__VITE_ASSET__1902354b__"